import React, { useState, useEffect, useContext } from 'react';
import Header from 'components/Header';
import { useSearchParams } from 'react-router-dom';
import { Input, Select, Tabs } from '@mantine/core';
import ActiveProjects from './components/activeProjects';
import DeactivatedProjects from './components/deactivatedProject';
import PrimaryButton from 'components/primaryButton';
import useGetAllProjects from './hooks/useGetAllProjects';
import { useDebouncedValue } from '@mantine/hooks';
import { AuthContext } from 'context/authContext';

import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filterIcon.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow.svg';

export default function MyProjects() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchText, setSearchtext] = useState('');

  const { authState } = useContext(AuthContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [debouncedValue] = useDebouncedValue(searchText, 200);

  // handle tabs change
  const handleTabChange = (e) => {
    setSearchParams({ tab: e });
  };

  const getAllProjects = useGetAllProjects(
    ~~searchParams.get('tab') === 1 ? false : true
  );

  useEffect(() => {
    if (debouncedValue) {
      setSearchParams({
        tab: searchParams.get('tab'),
        search: debouncedValue,
      });
    } else {
      setSearchParams({
        tab: searchParams.get('tab'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <div className='px-5'>
      <div className='flex justify-between items-center mt-6'>
        <p className='text-xl text-A8A8A8'>
          Projects &#60;{' '}
          <span className='text-gray font-semibold'> My projects</span>
        </p>
        <Header />
      </div>
      <div className='mt-8 relative'>
        <div>
          <Tabs
            active={~~searchParams.get('tab')}
            tabPadding={21}
            onTabChange={handleTabChange}
            classNames={{
              tabsListWrapper: 'border-0',
              tabActive: 'border-2 border-primary font-semibold text-18',
              tabControl: 'text-A8A8A8 leading-5 px-0 mr-4',
              tabLabel: 'text-18 text-gray',
            }}
          >
            <Tabs.Tab label='Active Projects'>
              <ActiveProjects
                getAllProjects={getAllProjects}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
              />
            </Tabs.Tab>
            <Tabs.Tab label='Inactive Projects'>
              <DeactivatedProjects getAllProjects={getAllProjects} />
            </Tabs.Tab>
          </Tabs>
        </div>
        <div className='absolute top-0 right-0 flex items-center space-x-5'>
          <Input
            icon={<SearchIcon />}
            // value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
            placeholder='Search'
            classNames={{
              wrapper: 'border-primary border-b',
              input: 'w-48  bg-light-bg border-none',
            }}
          />
          <Select
            data={[
              { value: '', label: 'All' },
              { value: 'Low', label: 'Low' },
              { value: 'Medium', label: 'Medium' },
              { value: 'High', label: 'High' },
            ]}
            value={searchParams.get('priority')}
            onChange={(value) => {
              if (value) {
                setSearchParams({
                  tab: searchParams.get('tab'),
                  priority: value,
                });
              } else {
                setSearchParams({
                  tab: searchParams.get('tab'),
                });
              }
            }}
            icon={<FilterIcon />}
            clearable
            rightSection={<DownArrowIcon />}
            placeholder='By priority'
            className='w-40'
            classNames={{
              rightSection: 'pointer-events-none',
              wrapper: 'border-primary border-b',
              input: '  bg-light-bg border-none',
            }}
          />
          <Select
            data={[
              { value: '', label: 'All' },
              { value: 'Not yet started', label: 'Not yet started' },
              { value: 'In progress', label: 'In progress' },
              { value: 'Almost there', label: 'Almost there' },
              { value: 'Completed', label: 'Completed' },
            ]}
            value={searchParams.get('status')}
            onChange={(value) => {
              if (value) {
                setSearchParams({
                  tab: searchParams.get('tab'),
                  status: value,
                });
              } else {
                setSearchParams({
                  tab: searchParams.get('tab'),
                });
              }
            }}
            placeholder='By status'
            icon={<FilterIcon />}
            clearable
            rightSection={<DownArrowIcon />}
            className='w-40'
            classNames={{
              rightSection: 'pointer-events-none',
              wrapper: 'border-primary border-b',
              input: '  bg-light-bg border-none',
            }}
          />
          {~~searchParams.get('tab') === 1 ||
          (!authState?.is_admin && !authState?.is_subadmin) ? null : (
            <div>
              {getAllProjects?.data?.data?.length ||
              searchParams.get('status') ||
              searchParams.get('priority') ||
              searchParams.get('search') ? (
                <button onClick={() => setIsModalOpen(true)}>
                  <PrimaryButton>+ Create project</PrimaryButton>
                </button>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
